/**
 * Freelancer User Management-specific translation keys
 */
export const freelancerUser = {
  list: {
    main_heading: "admin.freelancer_user_list_heading",
    search_placeholder: "admin.freelancer_user_search_placeholder",
    table: {
      user_name_col_heading: "admin.freelancer_user_table_user_name_col_heading",
      application_status_col_heading: "admin.freelancer_user_table_application_status_col_heading",
      verification_status_col_heading: "admin.freelancer_user_table_verification_status_col_heading",
      created_at_col_heading: "admin.freelancer_user_table_created_at_col_heading",
      deleted_at_col_heading: "admin.freelancer_user_table_deleted_at_col_heading",
      action_col_heading: "admin.freelancer_user_table_action_col_heading",
      reward_count_col_heading: "admin.freelancer_user_table_reward_count_col_heading",
    },
    premium_reward: {
      button_text: "admin.freelancer_user_grant_premium_reward_btn_text",
      months_not_configured_message: "admin.freelancer_user_grant_premium_reward_months_not_configured_message",
      confirm_heading: "admin.freelancer_user_grant_premium_reward_confirm_heading",
      confirm_message: "admin.freelancer_user_grant_premium_reward_confirm_message",
      confirm_yes_text: "admin.freelancer_user_grant_premium_reward_confirm_yes_text",
      confirm_no_text: "admin.freelancer_user_grant_premium_reward_confirm_no_text",
      success_message: "admin.freelancer_user_grant_premium_reward_success_message",
    },
    profile_status_filter: {
      all: "admin.freelancer_user_profile_status_filter_all",
      deleted: "admin.freelancer_user_profile_status_filter_deleted",
    },
    deleted_badge: "admin.freelancer_user_deleted_badge",
    application_status_filter: {
      placeholder: "admin.freelancer_user_application_status_filter_placeholder",
      not_applied: "admin.freelancer_user_application_status_not_applied",
      pending: "admin.freelancer_user_application_status_pending",
      approved: "admin.freelancer_user_application_status_approved",
      verified: "admin.freelancer_user_application_status_verified",
      rejected: "admin.freelancer_user_application_status_rejected",
    },
    verification_status_filter: {
      placeholder: "admin.freelancer_user_verification_status_filter_placeholder",
      not_submitted: "admin.freelancer_user_verification_status_not_submitted",
      pending: "admin.freelancer_user_verification_status_pending",
      approved: "admin.freelancer_user_verification_status_approved",
      rejected: "admin.freelancer_user_verification_status_rejected",
    },
    service_status_filter: {
      placeholder: "admin.freelancer_user_service_status_filter_placeholder",
      pending: "admin.freelancer_user_service_status_filter_pending",
      approved: "admin.freelancer_user_service_status_filter_approved",
      rejected: "admin.freelancer_user_service_status_filter_rejected",
    },
    profession_filter_placeholder: "admin.freelancer_user_profession_filter_placeholder",
    date_from_placeholder: "admin.freelancer_user_date_from_placeholder",
    date_to_placeholder: "admin.freelancer_user_date_to_placeholder",
    clear_filter_btn_text: "admin.freelancer_user_clear_filter_btn_text",
    view_tooltip: "admin.freelancer_user_view_tooltip",
    defaults: {
      na: "admin.freelancer_user_defaults_na",
    },
  },
  view: {
    main_heading: "admin.freelancer_user_view_heading",
    back_to_list: "admin.freelancer_user_back_to_list",
    error: {
      not_found: "admin.freelancer_user_not_found_heading",
      not_found_description: "admin.freelancer_user_not_found_description",
    },
    verified_badge: "admin.freelancer_user_verified_badge",
    deleted_badge: "admin.freelancer_user_deleted_badge",
    actions: {
      approve_application: "admin.freelancer_user_approve_application_btn",
      reject_application: "admin.freelancer_user_reject_application_btn",
      approve_documents: "admin.freelancer_user_approve_documents_btn",
      reject_documents: "admin.freelancer_user_reject_documents_btn",
    },
    approve_application_popup: {
      heading: "admin.freelancer_user_approve_application_popup_heading",
      message: "admin.freelancer_user_approve_application_popup_message",
      yes_btn_text: "admin.freelancer_user_approve_popup_yes_btn_text",
      no_btn_text: "admin.freelancer_user_approve_popup_no_btn_text",
    },
    reject_application_popup: {
      heading: "admin.freelancer_user_reject_application_popup_heading",
      message: "admin.freelancer_user_reject_application_popup_message",
      reason_placeholder: "admin.freelancer_user_reject_reason_placeholder",
      reason_required: "admin.freelancer_user_reject_reason_required",
      yes_btn_text: "admin.freelancer_user_reject_popup_yes_btn_text",
      no_btn_text: "admin.freelancer_user_reject_popup_no_btn_text",
    },
    approve_documents_popup: {
      heading: "admin.freelancer_user_approve_documents_popup_heading",
      message: "admin.freelancer_user_approve_documents_popup_message",
      yes_btn_text: "admin.freelancer_user_approve_popup_yes_btn_text",
      no_btn_text: "admin.freelancer_user_approve_popup_no_btn_text",
    },
    reject_documents_popup: {
      heading: "admin.freelancer_user_reject_documents_popup_heading",
      message: "admin.freelancer_user_reject_documents_popup_message",
      reason_placeholder: "admin.freelancer_user_reject_reason_placeholder",
      reason_required: "admin.freelancer_user_reject_reason_required",
      yes_btn_text: "admin.freelancer_user_reject_popup_yes_btn_text",
      no_btn_text: "admin.freelancer_user_reject_popup_no_btn_text",
    },
    messages: {
      approve_application_success: "admin.freelancer_user_approve_application_success",
      reject_application_success: "admin.freelancer_user_reject_application_success",
      approve_documents_success: "admin.freelancer_user_approve_documents_success",
      reject_documents_success: "admin.freelancer_user_reject_documents_success",
    },
    tabs: {
      personal_details: "admin.freelancer_user_tab_personal_details",
      contact_details: "admin.freelancer_user_tab_contact_details",
      profession: "admin.freelancer_user_tab_profession",
      services_offered: "admin.freelancer_user_tab_services_offered",
      availability: "admin.freelancer_user_tab_availability",
      portfolio_images: "admin.freelancer_user_tab_portfolio_images",
      verification_documents: "admin.freelancer_user_tab_verification_documents",
    },
    personal_details: {
      title: "admin.freelancer_user_personal_details_title",
      business_name_label: "admin.freelancer_user_business_name_label",
      user_name_label: "admin.freelancer_user_user_name_label",
      bio_label: "admin.freelancer_user_bio_label",
      account_status_label: "admin.freelancer_user_account_status_label",
      created_at_label: "admin.freelancer_user_created_at_label",
    },
    contact_details: {
      title: "admin.freelancer_user_contact_details_title",
      email_label: "admin.freelancer_user_email_label",
      mobile_number_label: "admin.freelancer_user_mobile_number_label",
      website_link_label: "admin.freelancer_user_website_link_label",
      instagram_link_label: "admin.freelancer_user_instagram_link_label",
      facebook_link_label: "admin.freelancer_user_facebook_link_label",
      linkedin_link_label: "admin.freelancer_user_linkedin_link_label",
    },
    profession_tab: {
      title: "admin.freelancer_user_profession_tab_title",
      primary_profession_label: "admin.freelancer_user_primary_profession_label",
      all_professions_label: "admin.freelancer_user_all_professions_label",
      no_professions: "admin.freelancer_user_no_professions",
      working_areas_label: "admin.freelancer_user_working_areas_label",
      no_working_areas: "admin.freelancer_user_no_working_areas",
    },
    services: {
      title: "admin.freelancer_user_services_title",
      table: {
        name_col_heading: "admin.freelancer_user_service_table_name_col_heading",
        price_col_heading: "admin.freelancer_user_service_table_price_col_heading",
        duration_col_heading: "admin.freelancer_user_service_table_duration_col_heading",
        status_col_heading: "admin.freelancer_user_service_table_status_col_heading",
        action_col_heading: "admin.freelancer_user_service_table_action_col_heading",
      },
      view_tooltip: "admin.freelancer_user_service_view_tooltip",
      actions: {
        approve: "admin.freelancer_user_service_approve_btn",
        reject: "admin.freelancer_user_service_reject_btn",
      },
      approve_popup: {
        heading: "admin.freelancer_user_service_approve_popup_heading",
        message: "admin.freelancer_user_service_approve_popup_message",
        yes_btn_text: "admin.freelancer_user_approve_popup_yes_btn_text",
        no_btn_text: "admin.freelancer_user_approve_popup_no_btn_text",
      },
      reject_popup: {
        heading: "admin.freelancer_user_service_reject_popup_heading",
        message: "admin.freelancer_user_service_reject_popup_message",
        yes_btn_text: "admin.freelancer_user_reject_popup_yes_btn_text",
        no_btn_text: "admin.freelancer_user_reject_popup_no_btn_text",
      },
      messages: {
        approve_success: "admin.freelancer_user_service_approve_success",
        reject_success: "admin.freelancer_user_service_reject_success",
      },
    },
    availability: {
      title: "admin.freelancer_user_availability_title",
      no_availability: "admin.freelancer_user_no_availability",
      open_label: "admin.freelancer_user_availability_open_label",
      closed_label: "admin.freelancer_user_availability_closed_label",
    },
    portfolio: {
      title: "admin.freelancer_user_portfolio_title",
      no_images: "admin.freelancer_user_no_portfolio_images",
    },
    documents: {
      title: "admin.freelancer_user_documents_title",
      no_documents: "admin.freelancer_user_no_documents",
      public_section_title: "admin.freelancer_user_documents_public_section_title",
      private_section_title: "admin.freelancer_user_documents_private_section_title",
      no_public_documents: "admin.freelancer_user_no_public_documents",
      no_private_documents: "admin.freelancer_user_no_private_documents",
    },
    rejection_reason_label: "admin.freelancer_user_rejection_reason_label",
    application_rejection_reason_label: "admin.freelancer_user_application_rejection_reason_label",
    document_rejection_reason_label: "admin.freelancer_user_document_rejection_reason_label",
    defaults: {
      na: "admin.freelancer_user_defaults_na",
    },
  },
  serviceDetail: {
    main_heading: "admin.freelancer_user_service_view_heading",
    back_btn: "admin.freelancer_user_service_back_btn",
    error: {
      not_found: "admin.freelancer_user_service_not_found_heading",
      not_found_description: "admin.freelancer_user_service_not_found_description",
    },
    details_title: "admin.freelancer_user_service_details_title",
    service_name_label: "admin.freelancer_user_service_name_label",
    description_label: "admin.freelancer_user_service_description_label",
    category_label: "admin.freelancer_user_service_category_label",
    price_label: "admin.freelancer_user_service_price_label",
    duration_label: "admin.freelancer_user_service_duration_label",
    negotiable_label: "admin.freelancer_user_service_negotiable_label",
    negotiable_yes: "admin.freelancer_user_service_negotiable_yes",
    negotiable_no: "admin.freelancer_user_service_negotiable_no",
    status_label: "admin.freelancer_user_service_status_label",
    addresses: {
      title: "admin.freelancer_user_service_addresses_title",
      no_addresses: "admin.freelancer_user_service_no_addresses",
      location_type_label: "admin.freelancer_user_service_address_location_type_label",
      house_number_label: "admin.freelancer_user_service_address_house_number_label",
      street_label: "admin.freelancer_user_service_address_street_label",
      zip_code_label: "admin.freelancer_user_service_address_zip_code_label",
      city_label: "admin.freelancer_user_service_address_city_label",
      region_label: "admin.freelancer_user_service_address_region_label",
      country_label: "admin.freelancer_user_service_address_country_label",
      coordinates_label: "admin.freelancer_user_service_address_coordinates_label",
    },
    images: {
      title: "admin.freelancer_user_service_images_title",
      no_images: "admin.freelancer_user_service_no_images",
    },
    defaults: {
      na: "admin.freelancer_user_defaults_na",
    },
  },
};
